import {Component} from '@angular/core';
import {MatLabel} from '@angular/material/form-field';
import {CustomFieldTypes, FormlyFieldTypes, HTMLInputFieldTypes} from '@models/form-field';
import {FieldType, FieldTypeConfig, FormlyFieldConfig} from '@ngx-formly/core';
import {phoneNumberOnInit} from '@validators/phone-number.validator';

@Component({
  selector: 'app-text-display-field',
  template: ` <div class="form-field standard">
    <mat-label class="form-field standard required">{{ props.label }}</mat-label>
    <span class="display-field-value" [innerHTML]="props['value']()"></span>
    <input type="hidden" [value]="props['value']()" class="cdk-visually-hidden" />
  </div>`,
  imports: [MatLabel],
})
export class TextDisplayField extends FieldType<FieldTypeConfig> {}

export function buildProjectCreateFields(storageOrganization: string): FormlyFieldConfig[] {
  return [
    {
      key: 'name',
      type: FormlyFieldTypes.INPUT,
      className: 'wide-form-field',
      props: {
        label: 'Project Title',
        required: true,
        type: HTMLInputFieldTypes.TEXT,
      },
    },
    {
      key: 'principal_investigators',
      type: CustomFieldTypes.CHIP_LIST,
      className: 'chip-list-field',
      props: {
        label: 'Project Lead / Principal Investigator Email(s)',
        required: true,
        invalidItemValidator: 'org-email',
      },
      validators: {validation: ['org-email']},
    },
    {
      key: 'description',
      type: CustomFieldTypes.RICH_TEXT,
      props: {
        label: 'Description',
        required: true,
      },
    },
    {
      key: 'keywords',
      type: CustomFieldTypes.CHIP_LIST,
      className: 'chip-list-field',
      props: {
        label: 'Keywords',
        required: true,
      },
    },
    {
      type: TextDisplayField,
      props: {
        label: 'Storage Organization',
        value: () => storageOrganization,
      },
    },
    {
      key: 'show_storage_organization_logo',
      type: FormlyFieldTypes.CHECKBOX,
      className: 'wide-form-field',
      defaultValue: true,
      props: {
        label: 'Show Storage Organization Logo',
      },
      wrappers: ['checkbox-wrapper'],
    },
    {
      key: 'partners',
      type: CustomFieldTypes.CHIP_LIST,
      className: 'chip-list-field',
      props: {
        label: 'Partner Institutions',
      },
    },
    {
      key: 'funders',
      type: CustomFieldTypes.CHIP_LIST,
      className: 'chip-list-field',
      props: {
        label: 'Funding Sources',
        //
      },
    },
    {
      key: 'contacts',
      type: 'repeat',
      defaultValue: [{}],
      fieldArray: {
        fieldGroup: [
          {key: 'name', type: 'input', props: {label: 'Contact Name'}},
          {
            key: 'email',
            type: FormlyFieldTypes.INPUT,
            props: {
              label: 'Contact Email',
              type: HTMLInputFieldTypes.EMAIL,
            },
            validators: {validation: ['email']},
          },
          {
            key: 'phone_number',
            type: FormlyFieldTypes.INPUT,
            props: {
              label: 'Contact Phone',
              type: HTMLInputFieldTypes.TEL,
            },
            validators: {validation: ['phone-number']},
            hooks: {onInit: phoneNumberOnInit},
          },
        ],
      },
      props: {hideAddButton: true, hideRemoveButton: true},
    },
    {
      key: 'website',
      type: FormlyFieldTypes.INPUT,
      className: 'wide-form-field',
      props: {
        label: 'Website',
        type: HTMLInputFieldTypes.URL,
        hint: 'Must start with https://',
      },
      validators: {validation: ['https-only']},
    },
    {
      key: 'associated_resource_ids',
      type: CustomFieldTypes.CHIP_LIST,
      className: 'chip-list-field',
      props: {
        label: 'Related Resources',
        invalidItemValidator: 'resource-url',
      },
      validators: {validation: ['resource-url']},
    },
  ];
}
